import React, { useContext, useState, Dispatch, SetStateAction } from 'react';
import { useStock, useCart } from 'frontastic';
import AdyenPaymentProvider, { AdyenContext } from './payment/adyen';

interface Props {
  hasOutOfStockItems: boolean;
  previousPaymentMethod: string | null;
  setPreviousPaymentMethod: Dispatch<SetStateAction<string | null>>;
  setHasOutOfStockItems: Dispatch<SetStateAction<boolean>>;
  scrollToError: (elementId: string) => void;
}

const initialValue: Props = {
  hasOutOfStockItems: false,
  previousPaymentMethod: '',
  setPreviousPaymentMethod: () => {},
  setHasOutOfStockItems: () => {},
  scrollToError: (elementId: string) => {},
};

const CheckoutContext = React.createContext<Props>(initialValue);

const CheckoutProvider = ({ children }: React.PropsWithChildren) => {
  const [hasOutOfStockItems, setHasOutOfStockItems] = useState(false);
  const [previousPaymentMethod, setPreviousPaymentMethod] = useState<string | null>(null);

  const scrollToError = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <CheckoutContext.Provider
      value={{
        hasOutOfStockItems,
        setHasOutOfStockItems,
        scrollToError,
        previousPaymentMethod,
        setPreviousPaymentMethod,
      }}
    >
      <AdyenPaymentProvider>{children}</AdyenPaymentProvider>
    </CheckoutContext.Provider>
  );
};

export default CheckoutProvider;

export const useAdyenCheckout = () => useContext(AdyenContext);
export const useCheckout = () => useContext(CheckoutContext);
